import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Dialog} from "../dialog/dialog";
import {AgentUserService} from "../../services/api/agent-user/agent-user.service";
import {OptionsApiService} from '../../services/api/options/options-api.service';
import {ApiService} from '../../services/api/api.service';
import { ApiAdminGroupsService } from 'src/app/services/api/admin/admin-groups-api/admin-groups-api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-agent-search-modal',
  templateUrl: './agent-search-modal.component.html',
  styleUrls: ['./agent-search-modal.component.css']
})
export class AgentSearchModalComponent implements OnInit {

  @Input() data;
  @Output() remove = new EventEmitter<any>();

  userList;
  selectedUserId = null;
  selectedUserIds: number[] = [];

  groupId = null;

  searchTerm = '';

  isLoading = true;
  response;
  errors;

  constructor(private agentUserApi : AgentUserService, private optionsApi: OptionsApiService, private api: ApiService, private memeberAdd:ApiAdminGroupsService,
    private toastr:ToastrService 
  ) {
    this.refreshUsers();
  }

  filteredUsers(){

    let filteredData  = this.userList;
    let searchTerm = this.searchTerm.toLocaleLowerCase();

    if(searchTerm){
      filteredData = filteredData.filter(user => {
        return user.name.toString().toLocaleLowerCase().includes(searchTerm)
      })
    }

    filteredData = filteredData.slice(0, 10);

    return filteredData;
  }

  refreshUsers() {
    this.isLoading = true;
    this.optionsApi.AllOptions().then(response => {
      this.userList = response.agent;
      this.isLoading = false;
    })
  }

  ngOnInit(): void {

    this.groupId = this.data;
  }

  closeModal(){
    console.log("Clicked Cancel...");
    this.selectedUserIds=[];
    this.remove.emit(null);
  }

  addUserId(id){
    if(this.selectedUserIds.includes(id)){
      this.selectedUserIds = this.selectedUserIds.filter(userId => userId !== id);
    }else{
      this.selectedUserIds = [...this.selectedUserIds, id];
    }
  }

  async save() {
    try {
      // Await the response
      this.response = await this.memeberAdd.AddGroupMembers(this.groupId, this.selectedUserIds);
      if(this.response){
        this.errors=this.response["error"]??null

        if (Array.isArray(this.errors)) {
          if (this.errors.length !== 0) {
            if(this.errors.length === 1){
              this.toastr.warning(`${this.errors.map(e => `"${e}"`).join(', ')} is already a member of this group`);
            }else{
              this.toastr.warning(`${this.errors.map(e => `"${e}"`).join(', ')} are already members of this group`);
            }
          }
        } else {
          this.toastr.warning("Response is not an array or is empty");
        }
      }
      this.remove.emit(true);
    } catch (error) {
      console.error('Error:', error);
      this.toastr.error("Failed to add members");
    }
  }

}
